import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/toggle_icon_left.svg'
import _imports_1 from '@/assets/icon/toggle_icon_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-f25370b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view main" }
const _hoisted_2 = { class: "top-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_DiskInfo = _resolveComponent("DiskInfo")!
  const _component_DicomFileUpload = _resolveComponent("DicomFileUpload")!
  const _component_DicomWebViewer = _resolveComponent("DicomWebViewer")!
  const _component_DicomOption = _resolveComponent("DicomOption")!
  const _component_ExportPopup = _resolveComponent("ExportPopup")!
  const _component_PacsPopup = _resolveComponent("PacsPopup")!
  const _component_PacsSettingPopup = _resolveComponent("PacsSettingPopup")!
  const _component_ResultListPopup = _resolveComponent("ResultListPopup")!
  const _component_LogoutAlertPopup = _resolveComponent("LogoutAlertPopup")!
  const _component_DeleteConfirmPopup = _resolveComponent("DeleteConfirmPopup")!
  const _component_DeleteDicomListConfirmPopup = _resolveComponent("DeleteDicomListConfirmPopup")!
  const _component_CompleteScoreSavePopup = _resolveComponent("CompleteScoreSavePopup")!
  const _component_DicomTagPopup = _resolveComponent("DicomTagPopup")!
  const _component_DuplicationPopup = _resolveComponent("DuplicationPopup")!
  const _component_DiskFullPopup = _resolveComponent("DiskFullPopup")!
  const _component_SessionConflictPopup = _resolveComponent("SessionConflictPopup")!
  const _component_NowUploadPopup = _resolveComponent("NowUploadPopup")!
  const _component_NowConnectPopup = _resolveComponent("NowConnectPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["left-panel", { close: _ctx.toggleLeft }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Logo),
        _createElementVNode("div", null, [
          _createVNode(_component_DiskInfo),
          _createElementVNode("button", {
            class: "btn__default blue logout-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
          }, "Logout")
        ])
      ]),
      _createVNode(_component_DicomFileUpload),
      _createElementVNode("div", {
        class: "panel-toggle",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleLeftPanel()))
      }, _hoisted_4)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["center-panel", [{ 'close': _ctx.toggleLeft && _ctx.toggleRight },
      { 'close-left': _ctx.toggleLeft && !_ctx.toggleRight },
      { 'close-right': _ctx.toggleRight && !_ctx.toggleLeft }]])
    }, [
      _createVNode(_component_DicomWebViewer)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["right-panel", { close: _ctx.toggleRight }])
    }, [
      _createVNode(_component_DicomOption),
      _createElementVNode("div", {
        class: "panel-toggle",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleRightPanel()))
      }, _hoisted_6)
    ], 2),
    (_ctx.exportPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_ExportPopup, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.pacsPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_PacsPopup, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.pacsSettingPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_PacsSettingPopup, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.resultListPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_ResultListPopup, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.logoutAlertPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_LogoutAlertPopup, { key: 4 }))
      : _createCommentVNode("", true),
    (_ctx.deleteConfirmPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_DeleteConfirmPopup, { key: 5 }))
      : _createCommentVNode("", true),
    (_ctx.deleteDicomConfirmPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_DeleteDicomListConfirmPopup, { key: 6 }))
      : _createCommentVNode("", true),
    (_ctx.completeScorePopupIsOpen)
      ? (_openBlock(), _createBlock(_component_CompleteScoreSavePopup, { key: 7 }))
      : _createCommentVNode("", true),
    (_ctx.dicomTagPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_DicomTagPopup, { key: 8 }))
      : _createCommentVNode("", true),
    (_ctx.duplicationPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_DuplicationPopup, { key: 9 }))
      : _createCommentVNode("", true),
    (_ctx.diskPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_DiskFullPopup, { key: 10 }))
      : _createCommentVNode("", true),
    (_ctx.sessionConflictPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_SessionConflictPopup, { key: 11 }))
      : _createCommentVNode("", true),
    (_ctx.nowLoadingPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_NowUploadPopup, { key: 12 }))
      : _createCommentVNode("", true),
    (_ctx.nowConnectPopupIsOpen)
      ? (_openBlock(), _createBlock(_component_NowConnectPopup, { key: 13 }))
      : _createCommentVNode("", true)
  ]))
}